import firebase from "@firebase/app";
import "@firebase/analytics";

export const save = (eventName, event) =>
  firebase.analytics().logEvent(eventName, event);

export default {
  save,
};
